<template>
  <div id="header" v-show="this.$route.meta.mainHeader">
    <a href="https://m.childy.co.kr/main/index.php" style="z-index:4;" class="btn_logo_home">
      <img src="https://childytr0265.cdn-nhncommerce.com/data/skin/mobile/pixm22_mo/img/banner/c4b0d0e25e021c8acdd4f5d686ce68ea_26693.svg" alt="상단 로고" title="상단 로고" class="btn_top_home">
    </a>
  </div>
</template>
<script>

export default{ 
  components:{},
  data(){
    return {
    }
  },
  setup(){},
  created(){},
  mounted(){},
  unmounted(){},
  methods:{}
}
</script>
<style>
@import '../../assets/css/common.css';
</style>